import http from "./http-service"

export default class ProductService {

  static getByCode(code) {
    return http.get(`products/${code}`)
  }

  static getProperties(property) {
    return http.get(`products/properties/${property}`).then((response) => response.properties)
  }

  static getColors(name, bitola) {
    return http.get(`products/colors/${name}/${bitola}`).then((response) => response.colors)
  }
}